import { render, staticRenderFns } from "./emergencyContact.vue?vue&type=template&id=eca0ae24&scoped=true&"
import script from "./emergencyContact.vue?vue&type=script&lang=js&"
export * from "./emergencyContact.vue?vue&type=script&lang=js&"
import style0 from "./emergencyContact.vue?vue&type=style&index=0&id=eca0ae24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca0ae24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eca0ae24')) {
      api.createRecord('eca0ae24', component.options)
    } else {
      api.reload('eca0ae24', component.options)
    }
    module.hot.accept("./emergencyContact.vue?vue&type=template&id=eca0ae24&scoped=true&", function () {
      api.rerender('eca0ae24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialogs/emergencyContact.vue"
export default component.exports